module.exports = __webpack_public_path__ + "img/paw.b9bf1e98.gif";